export const RUNS = [
  {
    id: "run_001",
    status: "PASSED",
    instruction: "Log in with standard_user / secret_sauce and verify the products page loads",
    url: "https://www.saucedemo.com",
    projectId: "p_shop",
    cost: 0.042,
    bug: null,
    duration_seconds: 14.2,
    user_id: "user_1",
    byAgent: { navigator: { calls: 3, cost_usd: 0.018 }, validator: { calls: 2, cost_usd: 0.024 } },
    steps: [
      { step: 1, action: "Navigate to login page", status: "passed", duration_ms: 2100 },
      { step: 2, action: "Enter username 'standard_user'", status: "passed", duration_ms: 800 },
      { step: 3, action: "Enter password 'secret_sauce'", status: "passed", duration_ms: 700 },
      { step: 4, action: "Click login button", status: "passed", duration_ms: 1200 },
      { step: 5, action: "Verify products page shows inventory items", status: "passed", duration_ms: 3400 },
    ],
    created_at: "2026-06-30T10:30:00Z",
  },
  {
    id: "run_002",
    status: "FAILED",
    instruction: "Add item to cart and verify cart badge updates correctly",
    url: "https://www.saucedemo.com/inventory.html",
    projectId: "p_shop",
    cost: 0.068,
    bug: { severity: "major", title: "Cart badge shows incorrect count", description: "After adding 2 items, cart badge shows 1 instead of 2." },
    duration_seconds: 22.8,
    user_id: "user_1",
    byAgent: { navigator: { calls: 4, cost_usd: 0.032 }, validator: { calls: 3, cost_usd: 0.036 } },
    steps: [
      { step: 1, action: "Navigate to inventory page", status: "passed", duration_ms: 1800 },
      { step: 2, action: "Click 'Add to cart' on first item", status: "passed", duration_ms: 900 },
      { step: 3, action: "Verify cart badge shows 1", status: "passed", duration_ms: 600 },
      { step: 4, action: "Click 'Add to cart' on second item", status: "passed", duration_ms: 800 },
      { step: 5, action: "Verify cart badge shows 2", status: "failed", duration_ms: 1200 },
    ],
    created_at: "2026-06-30T11:00:00Z",
  },
  {
    id: "run_003",
    status: "PASSED",
    instruction: "Verify logout flow from the hamburger menu",
    url: "https://www.saucedemo.com",
    projectId: "p_shop",
    cost: 0.031,
    bug: null,
    duration_seconds: 11.5,
    user_id: "user_1",
    byAgent: { navigator: { calls: 2, cost_usd: 0.012 }, validator: { calls: 2, cost_usd: 0.019 } },
    steps: [
      { step: 1, action: "Open hamburger menu", status: "passed", duration_ms: 1500 },
      { step: 2, action: "Click logout", status: "passed", duration_ms: 1100 },
      { step: 3, action: "Verify redirected to login page", status: "passed", duration_ms: 900 },
    ],
    created_at: "2026-06-29T15:20:00Z",
  },
  {
    id: "run_004",
    status: "FAILED",
    instruction: "Check error message for locked_out_user login attempt",
    url: "https://www.saucedemo.com",
    projectId: "p_shop",
    cost: 0.037,
    bug: { severity: "minor", title: "Error message not dismissible", description: "Error box has no close button or auto-dismiss timer." },
    duration_seconds: 9.1,
    user_id: "user_1",
    byAgent: { navigator: { calls: 2, cost_usd: 0.014 }, validator: { calls: 2, cost_usd: 0.023 } },
    steps: [
      { step: 1, action: "Navigate to login page", status: "passed", duration_ms: 1900 },
      { step: 2, action: "Enter username 'locked_out_user'", status: "passed", duration_ms: 600 },
      { step: 3, action: "Enter password 'secret_sauce'", status: "passed", duration_ms: 500 },
      { step: 4, action: "Click login button", status: "passed", duration_ms: 1000 },
      { step: 5, action: "Verify error message appears", status: "passed", duration_ms: 700 },
      { step: 6, action: "Verify error message has dismiss button", status: "failed", duration_ms: 400 },
    ],
    created_at: "2026-06-29T16:45:00Z",
  },
  {
    id: "run_005",
    status: "PASSED",
    instruction: "Verify product sorting by price (low to high) works",
    url: "https://www.saucedemo.com/inventory.html",
    projectId: "p_shop",
    cost: 0.045,
    bug: null,
    duration_seconds: 16.3,
    user_id: "user_2",
    byAgent: { navigator: { calls: 3, cost_usd: 0.021 }, validator: { calls: 3, cost_usd: 0.024 } },
    steps: [
      { step: 1, action: "Navigate to inventory page", status: "passed", duration_ms: 1700 },
      { step: 2, action: "Open sort dropdown", status: "passed", duration_ms: 800 },
      { step: 3, action: "Select 'Price (low to high)'", status: "passed", duration_ms: 600 },
      { step: 4, action: "Verify items sorted by price ascending", status: "passed", duration_ms: 3200 },
    ],
    created_at: "2026-06-28T09:15:00Z",
  },
];

export const API_KEYS = [
  { id: "ak_1", name: "Production CI", masked: "aqe_****_a1b2", created_at: "2026-06-01T00:00:00Z", last_used_at: "2026-06-30T12:00:00Z" },
  { id: "ak_2", name: "Staging Env", masked: "aqe_****_c3d4", created_at: "2026-06-05T00:00:00Z", last_used_at: "2026-06-29T08:30:00Z" },
  { id: "ak_3", name: "Dev Testing", masked: "aqe_****_e5f6", created_at: "2026-06-10T00:00:00Z", last_used_at: "2026-06-28T16:00:00Z" },
];

export const AGENT_COST = [
  { agent: "Navigator", calls: 120, cost: 18.40 },
  { agent: "Validator", calls: 95, cost: 22.10 },
  { agent: "Screenshotter", calls: 60, cost: 9.80 },
  { agent: "Bug Reporter", calls: 40, cost: 12.30 },
];

export const RUNS_PER_DAY = [3, 5, 2, 7, 4, 8, 6];

export const USERS = [
  { id: "u_1", name: "Alice Johnson", email: "alice@testcorp.com", role: "tester", status: "active", runs: 45, created_at: "2026-01-15T00:00:00Z" },
  { id: "u_2", name: "Bob Smith", email: "bob@testcorp.com", role: "tester", status: "active", runs: 32, created_at: "2026-02-10T00:00:00Z" },
  { id: "u_3", name: "Carol Davis", email: "carol@testcorp.com", role: "admin", status: "active", runs: 18, created_at: "2026-01-20T00:00:00Z" },
  { id: "u_4", name: "Dave Wilson", email: "dave@devfirm.io", role: "tester", status: "active", runs: 27, created_at: "2026-03-05T00:00:00Z" },
  { id: "u_5", name: "Eve Martin", email: "eve@devfirm.io", role: "superadmin", status: "active", runs: 8, created_at: "2026-01-01T00:00:00Z" },
  { id: "u_6", name: "Frank Lee", email: "frank@startup.co", role: "tester", status: "inactive", runs: 3, created_at: "2026-04-12T00:00:00Z" },
];

export const COMPANIES = [
  { id: "c_1", name: "TestCorp Inc.", is_active: true, plan_id: "growth", status: "active", runs: 4500, seats: 15 },
  { id: "c_2", name: "DevFirm LLC", is_active: true, plan_id: "starter", status: "active", runs: 1200, seats: 5 },
  { id: "c_3", name: "Startup Co.", is_active: true, plan_id: "free_trial", status: "trialing", runs: 45, seats: 3 },
  { id: "c_4", name: "BigCorp Ltd.", is_active: false, plan_id: "custom", status: "canceled", runs: 8900, seats: 50 },
  { id: "c_5", name: "MidSize GmbH", is_active: true, plan_id: "growth", status: "active", runs: 3200, seats: 22 },
];

export const AUDIT_LOG = [
  { id: "al_1", action: "user.login", at: "2026-06-30T10:00:00Z" },
  { id: "al_2", action: "project.created", at: "2026-06-30T10:15:00Z" },
  { id: "al_3", action: "api_key.generated", at: "2026-06-30T10:30:00Z" },
  { id: "al_4", action: "user.invited", at: "2026-06-29T14:00:00Z" },
  { id: "al_5", action: "guardrail.updated", at: "2026-06-29T11:20:00Z" },
  { id: "al_6", action: "subscription.changed", at: "2026-06-28T09:00:00Z" },
  { id: "al_7", action: "user.deleted", at: "2026-06-27T16:30:00Z" },
  { id: "al_8", action: "company.suspended", at: "2026-06-26T08:45:00Z" },
];

export const SAVED_TESTS = [
  { id: "st_1", name: "Login - Standard User", instruction: "Log in with standard_user / secret_sauce and verify the products page loads", url: "https://www.saucedemo.com", last_status: "PASSED", runs: 12 },
  { id: "st_2", name: "Cart - Add and Verify", instruction: "Add item to cart and verify cart badge updates correctly", url: "https://www.saucedemo.com/inventory.html", last_status: "FAILED", runs: 5 },
  { id: "st_3", name: "Logout Flow", instruction: "Verify logout flow from the hamburger menu", url: "https://www.saucedemo.com", last_status: "PASSED", runs: 8 },
  { id: "st_4", name: "Sort by Price", instruction: "Verify product sorting by price (low to high) works", url: "https://www.saucedemo.com/inventory.html", last_status: "PASSED", runs: 3 },
  { id: "st_5", name: "Empty Cart Checkout", instruction: "Try to checkout with an empty cart and verify the error message", url: "https://www.saucedemo.com/cart.html", last_status: null, runs: 0 },
];
